// src/components/OurServices.js

import React from 'react';
import './OurService.css';
import supportImg from '../imgs/Spare-Parts.webp';
import sparePartsImg from '../imgs/Lifetims.webp';
import trainingImg from '../imgs/operationt.webp';
import moldTestingImg from '../imgs/Plastic.webp';

const services = [
  {
    icon: 'fa-earth-asia',
    title: 'Agent In Worldwide',
    description: 'Setting up agent in more than 20 countries for sales and support',
  },
  {
    image: sparePartsImg,
    title: 'Spare Parts',
    description: 'We supply screw, motor, control panel and plastic mold for machines',
  },
  {
    image: supportImg,
    title: 'Lifetime Support',
    description: '24 hours online service and overseas installation & maintenance',
  },
  
  {
    image: trainingImg,
    title: 'Operation Training',
    description: 'Support training to engineer for setup, processing & troubleshooting',
  },
  {
    image: moldTestingImg,
    title: 'Plastic Mold Testing',
    description: 'Provide testing mold service before customer receiving the machine',
  },
];

const OurService = () => {
  return (
    <section className="services-section">
      <h2 className="section-title">Our Services</h2>
      <div className="services-grid" >
        {services.map((service, index) => (
          <div className="service-card" data-aos="flip-down" key={index}>
            {service.image ? (
              <img src={service.image} alt={service.title} className="service-img" />
            ) : (
              <i className={`fas ${service.icon} service-icon`}></i>
            )}
            <h3>{service.title}</h3>
            <p>{service.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default OurService;
